export default __webpack_public_path__ + "static/media/item-info.0dea5079.svg";